import React from "react";

export default function MainHeader(props) {
  const { title } = props;
  return <span style={{fontSize:"16px", fontWeight:"bold"}}>{title}</span>;
}
